import React, { useEffect, useState } from 'react'
import { MenuButtonIcon } from './index.styled'

const MenuButton = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const menu = document.querySelector('#menu')
    if (!menu) return undefined

    const syncOpenState = () => {
      setIsOpen(menu.classList.contains('open'))
    }

    syncOpenState()

    const observer = new MutationObserver(syncOpenState)
    observer.observe(menu, { attributes: true, attributeFilter: ['class'] })

    return () => observer.disconnect()
  }, [])

  const onClick = () => {
    const menu = document.querySelector('#menu')
    if (!menu) return
    menu.classList.toggle('open')
  }

  return (
    <MenuButtonIcon
      type="button"
      onClick={onClick}
      className={className}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isOpen}
      aria-controls="site-navigation"
    />
  )
}

export default MenuButton
